var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0752 8C16.0752 12.1837 12.6837 15.5752 8.5 15.5752C4.31633 15.5752 0.924805 12.1837 0.924805 8C0.924805 3.81633 4.31633 0.424805 8.5 0.424805C12.6837 0.424805 16.0752 3.81633 16.0752 8Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 5.64978,
    r: 2.30212,
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55908 13.2666C2.69096 10.9524 4.13852 8.93446 6.30138 8.0459C7.53377 9.18658 9.43649 9.18658 10.6689 8.0459C12.8347 8.93326 14.2685 10.9655 14.4038 13.2813C14.1437 13.5726 13.8797 13.8618 13.5798 14.1122V13.6533C13.5798 11.7028 12.492 9.93078 10.7872 9.03892C9.40411 9.99066 7.5668 9.99078 6.18359 9.03929C4.48436 9.9308 3.40065 11.6985 3.40065 13.6438V14.0713C3.10056 13.8208 2.81923 13.5582 2.55908 13.2666Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonCircleOutline);
export default __webpack_public_path__ + "static/media/person-circle-outline.57336f495408ee8520a7ca242e5c0783.svg";
export { ForwardRef as ReactComponent };